
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop } from "vue-property-decorator";
    import { ILookupItem } from "@/model/LookupItem";
    import { VisitSearchResult } from "@/model/VisitSearchResult";
    import { VisitAnswer } from "@/model/VisitAnswer";
    import { TriState } from "@/model/Enums";
    import Utils from "@/utilities/Utils";

    @Component({})
    export default class VisitViewDetail extends Vue {

        @Prop({ required: true })
        visitSearchResult!: VisitSearchResult;

        @Prop({ required: true })
        visitorCompanyList!: Array<ILookupItem>;

        @Prop({ required: true })
        recipientList!: Array<ILookupItem>;

        // so can access in template
        TriState: any = TriState;

        get incorrectAnswers(): Array<VisitAnswer> {
            if(this.visitSearchResult.visit?.answers == null) return [];
            // make sure red lines come first - but preserve order otherwise
            const redLine = this.visitSearchResult.visit.answers.filter(a => a.isTest && a.isRedLine && a.isCorrect !== TriState.True);
            const nonRedLine = this.visitSearchResult.visit.answers.filter(a => a.isTest && !a.isRedLine && a.isCorrect !== TriState.True);
            return redLine.concat(nonRedLine);
        }

        get areIncorrectAnswers(): boolean {
            return this.incorrectAnswers.length > 0;
        }

        get shouldShowResult(): boolean {
            return this.visitSearchResult.visit?.answers?.length > 0
                && Utils.hasDateValue(this.visitSearchResult.visit.completed);
        }
    }
